import React from 'react';
import { Status } from '../types';

interface ProgressTrackerProps {
  status: Status;
  onChange?: (status: Status) => void;
  readonly?: boolean;
}

const steps: Status[] = ['Open', 'In Progress', 'Closed'];

const stepIndex: Record<Status, number> = {
  'Open': 0,
  'In Progress': 1,
  'Closed': 2,
};

export default function ProgressTracker({ status, onChange, readonly = false }: ProgressTrackerProps) {
  const currentIndex = stepIndex[status];
  const progressPercent = (currentIndex / (steps.length - 1)) * 100;

  return (
    <div className="progress-tracker">
      <div className="progress-bar-container">
        <div className="progress-bar-track">
          <div
            className="progress-bar-fill"
            style={{ width: `${progressPercent}%` }}
          />
        </div>
        <div className="progress-steps">
          {steps.map((step, idx) => {
            const isCompleted = idx <= currentIndex;
            const isCurrent = idx === currentIndex;
            const isClickable = !readonly && onChange;

            return (
              <button
                key={step}
                className={`progress-step ${isCompleted ? 'completed' : ''} ${isCurrent ? 'current' : ''} ${isClickable ? 'clickable' : ''}`}
                onClick={() => isClickable && onChange(step)}
                disabled={!isClickable}
                type="button"
                title={readonly ? step : `Set status to ${step}`}
              >
                <div className="progress-step-circle">
                  {isCompleted && idx < currentIndex ? (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  ) : (
                    <span>{idx + 1}</span>
                  )}
                </div>
                <span className="progress-step-label">{step}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
